module.exports = __webpack_public_path__ + "li.34c242f5ecb82d56d741.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/li.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/li.svg
// module chunks = styles